import { useCallback, useEffect, useState } from 'react';
import {
  ClearOutlined,
  EllipsisOutlined,
  FilterOutlined,
} from '@ant-design/icons';
import { GridApi } from 'ag-grid-community';
import { Button, Dropdown } from 'antd';
import { DropdownButtonProps } from 'antd/lib/dropdown';
import { observer } from 'mobx-react-lite';

type FiltersButtonProps = {
  gridApi: GridApi | null;
  onShowFilters: () => void;
  onResetAll: () => void;
  style?: DropdownButtonProps['style'];
};

export const FiltersButton = observer(
  ({ gridApi, style, onShowFilters, onResetAll }: FiltersButtonProps) => {
    const checkActiveFilters = useCallback(() => {
      if (!gridApi) return false;

      return gridApi.isAnyFilterPresent();
    }, [gridApi]);

    const [hasActiveFilters, setActiveFilters] = useState(() =>
      checkActiveFilters(),
    );

    useEffect(
      function hasActiveFilters() {
        if (!gridApi) return;

        const handleFiltersUpdate = () => {
          setActiveFilters(checkActiveFilters());
        };

        gridApi.addEventListener('filterChanged', handleFiltersUpdate);

        return () => {
          gridApi.removeEventListener('filterChanged', handleFiltersUpdate);
        };
      },
      [checkActiveFilters, gridApi],
    );

    return (
      <Dropdown.Button
        buttonsRender={() => [
          <Button
            type={hasActiveFilters ? 'primary' : 'default'}
            onClick={onShowFilters}
            icon={
              <FilterOutlined
                style={{ color: hasActiveFilters ? '#FFF' : '#2664CD' }}
              />
            }
          >
            Фильтры
          </Button>,
          <Button
            type={hasActiveFilters ? 'primary' : 'default'}
            icon={
              <EllipsisOutlined
                style={{ color: hasActiveFilters ? '#FFF' : '#2664CD' }}
              />
            }
          />,
        ]}
        menu={{
          items: [
            {
              key: '1',
              label: 'Очистить ',
              icon: <ClearOutlined />,
              // itemIcon: <ClearOutlined />,
            },
          ],
          onClick: onResetAll,
        }}
        style={style}
      />
    );
  },
);
